module.exports = __webpack_public_path__ + "static/media/wa.7281fc0c.svg";